<template>
  <div class="recurring-settings">
    <div class="content" id="schedule">
      <h1>{{ $t('pages.recurring-settings.headline') }}</h1>

      <div class="schedule-call-container">
        <p>{{ $t('pages.recurring-settings.text-1') }} {{ $t('pages.recurring-settings.text-2') }}</p>
        <RecurringDatetimePicker :settings="true" :hideTitle="true" ref="picker"/>
      </div>
      <div class="confirm-call-container">
        <p
          :class="{ hidden: !error.isShown }"
          class="error">{{ error.text }}</p>
        <PhoneInputContainer on-submit="recurring-settings" :button-text="$t('components.phoneinput.change-settings')" :hide-button-small="true"/>
      </div>
    </div>
  </div>
</template>

<script>
import { resolveJSON } from '@/helperfunctions'
import RecurringDatetimePicker from '@/components/RecurringSignup/RecurringDatetimePicker'
import PhoneInputContainer from '@/components/SectionCalling/PhoneInputContainer'
import CountriesMixin from '@/mixins/CountriesMixin.vue'
import { DateTime } from 'luxon'

export default {
  name: 'recurring-settings',
  components: {
    RecurringDatetimePicker,
    PhoneInputContainer,
  },
  data () {
    return {
      error: {
        isShown: false,
        text: '',
      }
    }
  },
  computed: {
    anyWeekday () {
      return this.$root.recurringPicker.weekday.Monday ||
        this.$root.recurringPicker.weekday.Tuesday ||
        this.$root.recurringPicker.weekday.Wednesday ||
        this.$root.recurringPicker.weekday.Thursday ||
        this.$root.recurringPicker.weekday.Friday
    }
  },
}
</script>


<style lang=scss>
@import '@/assets/styles/_variable.scss';

.recurring-settings {
  display: flex;
  flex-direction: column;

  .content {
    min-height: 100vh;
    background-color: white;
    max-width: 900px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0 auto 1em;
    padding: 2em;

    h1 {
      font-size: 2em;
      line-height: 1em;
      margin: 0em;
    }
    p {
      margin: 0.2em;

      span.highlight {
        background-color: $dark-text-color;
        color: $main-bg;
        padding: 0 2px;
      }
    }

    .schedule-call-container {
      h2 {
        font-size: 1.5em;
        text-align: center;
      }
    }
  }
}
</style>
